
export const BLOCK_TYPES = {
    GRAPHIC: 'graphic',
    TEXT: 'text',
    FORM: 'form',
    ACTION: 'action',
    OTHER: 'other',
}
